type TListener<T> = (value: T) => void

export class Observable<T> {
  private listeners: TListener<T>[] = []

  constructor(private value: T) {}

  addEventListener(listener: TListener<T>) {
    this.listeners.push(listener)
    return () => {
      this.listeners = this.listeners.filter((l) => l !== listener)
    }
  }

  set(value: T) {
    this.value = value

    for (const listener of this.listeners) {
      listener(value)
    }
  }

  get() {
    return this.value
  }
}
